import en from './en';
import thTH from './th-TH';
import vn from './vn';

export default {
  en,
  'th-TH': thTH,
  vn,
};
